module.exports = __webpack_public_path__ + "static/media/blacklogo.f60c59dc.svg";